// The control registry (plan, "UI: modular"): which component draws each
// resolved `ui.control`. Adding a control is adding a component and a line
// here; the form never names one.

import type { ComponentType } from 'react';
import type { ControlKind, ResolvedSetting } from '../types';
import { NumberControl } from './controls/NumberControl';
import { SelectControl } from './controls/SelectControl';
import { SliderControl } from './controls/SliderControl';
import { StepperControl } from './controls/StepperControl';
import { SwitchControl } from './controls/SwitchControl';
import { TextControl } from './controls/TextControl';
import type { ControlProps } from './controls/types';
import { defaultControl } from './resolve';

export type { ControlProps };

export const controlRegistry: Record<ControlKind, ComponentType<ControlProps>> = {
  number: NumberControl,
  slider: SliderControl,
  stepper: StepperControl,
  switch: SwitchControl,
  select: SelectControl,
  text: TextControl,
};

/** The component for a setting: its resolved control, else our default for its type. */
export function controlFor(setting: ResolvedSetting): ComponentType<ControlProps> {
  return controlRegistry[setting.ui.control] ?? controlRegistry[defaultControl(setting)];
}
